var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [_vm._v("Form Feature")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.formEntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "formEntegration", $$v)
                  },
                  expression: "featureForm.formEntegration",
                },
              },
              [_vm._v("Form Aktif")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Form Oluşturma Limiti"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.formLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "formLimit", $$v)
                },
                expression: "featureForm.formLimit",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Form Submit Limit"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.formSubmitLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "formSubmitLimit", $$v)
                },
                expression: "featureForm.formSubmitLimit",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Form Başına Görüntüleme Limiti"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.formViewLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "formViewLimit", $$v)
                },
                expression: "featureForm.formViewLimit",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "feature-label" }, [
          _vm._v("Form Alan Sayısı"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.formFieldLimit,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "formFieldLimit", $$v)
                },
                expression: "featureForm.formFieldLimit",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }